import { render, staticRenderFns } from "./GliEditable.vue?vue&type=template&id=957608ba&scoped=true&"
import script from "./GliEditable.vue?vue&type=script&lang=js&"
export * from "./GliEditable.vue?vue&type=script&lang=js&"
import style0 from "./GliEditable.vue?vue&type=style&index=0&id=957608ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957608ba",
  null
  
)

export default component.exports